// ============================================================
// VCS.LiveCapNotice -- Hinweis und Nachkauf im laufenden Gespraech
// ============================================================
// Gruender-Entscheidung 30.08.2026: Der Nutzer soll nachkaufen koennen,
// BEVOR die Uebersetzung ausgeht -- das ist der Moment, in dem er merkt,
// dass er sie braucht. Danach ist das Gespraech vorbei und mit ihm der
// Anlass.
//
// Zwei Nachrichten vom Server (helpers.js, _bookLiveCap):
//   'live-cap-low'     -- Rest unter LIVE_CAP_WARN_SECONDS (Vorgabe 300 s).
//                         Kommt einmal je Gespraechsabschnitt, nicht jede
//                         Minute neu.
//   'live-cap-expired' -- Kontingent UND Guthaben leer (scope 'total') oder
//                         das Sub-Kontingent fuer Gruppen mit 3+ Sprachen
//                         (scope 'group').
//
// Der Kauf laeuft in einem eigenen Tab (siehe chat-setup.js
// startPackageCheckout) -- der Anruf darf davon nicht abreissen. Die
// Rueckmeldung kommt ueber den bestehenden WebSocket als 'live-cap-update'
// mit purchasedMinutes, nicht ueber die Rueckkehr aus dem Stripe-Tab.
//
// Die Leiste haengt wie der Toast-Container auf Dokument-Ebene, nicht in
// #callScreen: sie soll im 1:1-Call und im Gruppen-Grid gleich sitzen.
// ============================================================
window.VCS = window.VCS || {};

VCS.LiveCapNotice = class {

    // Wie lange die Vorwarnung stehen bleibt. Der Ablauf-Hinweis bleibt dagegen,
    // bis der Nutzer ihn wegtippt -- dort ist die Uebersetzung wirklich aus.
    static LOW_AUTOHIDE_MS = 30000;

    constructor() {
        // null | 'low' | 'expired' -- steuert, ob eine neue Meldung die alte
        // ueberschreiben darf: der Ablauf verdraengt die Vorwarnung, umgekehrt
        // nicht.
        this._mode = null;
        this._hideTimer = 0;
        // Haben WIR die Pipeline wegen des Caps angehalten? Nur dann darf ein
        // Kauf sie wieder anwerfen -- sonst startet ein Kauf aus den
        // Einstellungen heraus ungefragt eine Aufnahme.
        this._pausedByCap = false;
        // Der Server hat die Live-Uebersetzung fuer dieses Gespraech gesperrt.
        // Getrennt von _pausedByCap: der merkt sich nur, ob WIR eine laufende
        // Aufnahme angehalten haben. Die Sperre kommt aber oft, BEVOR die
        // Aufnahme ueberhaupt lief (der Server meldet sie beim Call-Aufbau) --
        // dann gibt es nichts anzuhalten, und ohne eigenen Merker startet die
        // Aufnahme eine Sekunde spaeter ungehindert. captions.js fragt das in
        // startAutoCapture ab. Zurueckgesetzt beim Kauf, bei einer Freigabe und
        // am Ende des Gespraechs (reset).
        this._blocked = false;
        // Pakete einmal je Sitzung zeichnen; ein Tarifwechsel setzt zurueck
        // (resetPackages, gerufen aus chat-setup.js).
        this._packagesRendered = false;
        this._view = null;
    }

    init() {
        this._view = {
            notice     : $('#callCapNotice'),
            noticeText : $('#callCapNoticeText'),
            btnBuy     : $('#btnCallCapBuy'),
            btnClose   : $('#btnCallCapClose'),
            overlay    : $('#minutesSheetOverlay'),
            balance    : $('#minutesSheetBalance'),
            list       : $('#minutesSheetList'),
            consent    : $('#minutesSheetConsent'),
        };

        this._view.btnBuy.on('click', () => this.openSheet());
        this._view.btnClose.on('click', () => this._hideNotice());
        $('#btnMinutesSheetClose').on('click', () => this.closeSheet());
        // Klick auf den abgedunkelten Rand schliesst -- der Anruf laeuft
        // weiter, das Blatt darf nicht im Weg stehen.
        this._view.overlay.on('click', (e) => {
            if (e.target === this._view.overlay[0]) this.closeSheet();
        });
    }

    // ── Server-Nachrichten ───────────────────────────────────

    onLow(msg) {
        // Der Ablauf-Hinweis steht schon: eine Vorwarnung waere dann nur noch
        // ein Rueckschritt.
        if (this._mode === 'expired') return;
        const min = Math.max(1, Math.ceil((msg.remaining || 0) / 60));
        this._show('low',
            (t('liveCapLowNotice') || '').replace('{min}', String(min)),
            !!msg.canBuy);
        clearTimeout(this._hideTimer);
        this._hideTimer = setTimeout(() => this._hideNotice(),
            VCS.LiveCapNotice.LOW_AUTOHIDE_MS);
    }

    // Darf die Aufnahme starten? captions.js fragt das vor jedem Start.
    isBlocked() {
        return this._blocked;
    }

    onExpired(msg) {
        const scope = msg.scope === 'group' ? 'group' : 'total';
        this._blocked = true;
        // Pipeline anhalten wie beim Ablauf des Pro-Trials: der Server
        // verwirft das Audio ohnehin, weitersenden kostet nur Bandbreite und
        // laesst das Mikrofon-Symbol faelschlich aktiv aussehen.
        if (VCS.state.captionStreaming) {
            this._pausedByCap = true;
            VCS.captions?.releasePipeline();
            VCS.captions?.updateFabUI?.();
        }
        // Kaufrecht kommt vom Server: es haengt am Tarif UND am Schalter
        // MINUTES_FREE_PURCHASE, den der Client nicht kennt. Fehlt das Feld (aelterer
        // Server), lieber keinen Knopf zeigen als einen, der in einem 403 endet.
        // Gast-Seite: der Gast hat kein Kontingent und kann nichts kaufen --
        // er bekommt nur den neutralen Hinweis, dass die Uebersetzung aus ist.
        const isGuest = !!VCS.state.guestKey;
        const canBuy = msg.canBuy === true && !isGuest;
        let text = scope === 'group'
            ? (t('liveCapGroupExpiredNotice') || '')
            : (t('liveCapExpiredNotice') || '');
        if (isGuest) {
            text = t('guestTranslationOffNotice') || '';
        }
        this._show('expired', text, canBuy);
        clearTimeout(this._hideTimer);
        this._hideTimer = 0;
    }

    // Minuten teilen (2026-08-31, Plan Abschnitt 5): das Guthaben des
    // Sponsors ist mitten im Gespraech leer gelaufen. Neutral -- "dein
    // Partner hat kein Geld mehr" waere falsch, der Empfaenger soll nichts
    // ueber den Kontostand des Sponsors erfahren. Kein Kauf-Knopf: das
    // Guthaben, das ausging, war nicht seins. Bleibt stehen wie ein
    // Ablauf-Hinweis, bis der Nutzer ihn wegtippt -- die Uebersetzung ist
    // fuer ihn wirklich aus.
    onShareEnded() {
        this._blocked = true;
        if (VCS.state.captionStreaming) {
            this._pausedByCap = true;
            VCS.captions?.releasePipeline();
            VCS.captions?.updateFabUI?.();
        }
        this._show('expired', t('liveShareEndedNotice') || '', false);
        clearTimeout(this._hideTimer);
        this._hideTimer = 0;
    }

    // Minuten teilen (31.08.2026): jemand hat gerade angefangen, mit mir zu
    // teilen. Stand meine Aufnahme still, weil kein Kontingent da war, muss
    // sie jetzt wieder anlaufen -- den Erkenner hat der Server schon
    // nachtraeglich geoeffnet (routes.js, POST /minutes/share). Ohne das
    // wirkte eine Freigabe mitten im Gespraech erst beim naechsten Anruf,
    // und genau mittendrin wird sie erteilt.
    onShareStarted() {
        this._hideNotice();
        // Beide Merker zaehlen: _pausedByCap, wenn wir eine laufende Aufnahme
        // angehalten haben, _blocked, wenn sie wegen der Sperre gar nicht erst
        // angelaufen ist. Loeschen muss vor startAutoCapture stehen -- sonst
        // blockt die Abfrage in captions.js den eigenen Neustart.
        const warGesperrt = this._blocked || this._pausedByCap;
        this._blocked = false;
        this._pausedByCap = false;
        if (!warGesperrt) return;
        // Wie bei onPurchase: nur anwerfen, solange das Gespraech laeuft --
        // sonst startet eine Freigabe nach dem Auflegen eine Aufnahme.
        const s = VCS.state;
        const inCall = s.groupCallActive || s.sessionState?.phase === 'call';
        if (!inCall) return;
        VCS.captions?.startAutoCapture().catch(() => {});
        VCS.captions?.updateFabUI?.();
    }

    // Kauf durch, Minuten sind gutgeschrieben (Server: 'live-cap-update' mit
    // purchasedMinutes). Die Bestaetigung als Toast kommt aus signaling.js.
    onPurchase() {
        this.closeSheet();
        this._hideNotice();
        // Siehe onShareStarted: die Sperre kann die Aufnahme angehalten haben
        // (_pausedByCap) oder ihren Start verhindert haben (_blocked).
        const warGesperrt = this._blocked || this._pausedByCap;
        this._blocked = false;
        this._pausedByCap = false;
        if (!warGesperrt) return;
        // Nur wieder anwerfen, wenn das Gespraech ueberhaupt noch laeuft --
        // sonst startet der Kauf nach dem Auflegen eine Aufnahme.
        const s = VCS.state;
        const inCall = s.groupCallActive || s.sessionState?.phase === 'call';
        if (!inCall) return;
        VCS.captions?.startAutoCapture().catch(() => {});
        VCS.captions?.updateFabUI?.();
    }

    // Gespraech beendet -- alles zurueck auf Anfang. Ohne das stuende die
    // Warnung des letzten Anrufs beim naechsten wieder da.
    reset() {
        clearTimeout(this._hideTimer);
        this._hideTimer = 0;
        this._mode = null;
        this._pausedByCap = false;
        this._blocked = false;
        this._view?.notice?.addClass('hidden');
        this.closeSheet();
    }

    // Tarifwechsel: Preise haengen am Plan, die alte Liste ist damit hinfaellig.
    resetPackages() {
        this._view?.list?.empty();
        this._packagesRendered = false;
    }

    // ── Kauf-Blatt ───────────────────────────────────────────

    async openSheet() {
        if (!this._view) return;
        this._updateBalance();
        this._view.overlay.removeClass('hidden');
        if (this._packagesRendered) return;
        const packages = await VCS.chatSetup?.fetchMinutePackages?.();
        if (!packages) {
            // Ohne Preise ist das Blatt leer und nur im Weg -- lieber zu und
            // eine Meldung. Der Hinweis oben bleibt stehen, der Knopf auch.
            this.closeSheet();
            VCS.ui?.showToast?.(t('minutesCheckoutFailed') || '', 'error', 6000);
            return;
        }
        this._packagesRendered = true;
        VCS.chatSetup?.renderMinutePackages(this._view.list[0], packages,
            (pkgId, btn) => this._buy(pkgId, btn));
    }

    closeSheet() {
        this._view?.overlay?.addClass('hidden');
    }

    _updateBalance() {
        const extraMin = Math.floor((VCS.state.chatLiveExtraSeconds || 0) / 60);
        this._view.balance.text((t('minutesBalance') || '').replace('{min}', String(extraMin)));
    }

    async _buy(packageId, btn) {
        const consentEl = this._view.consent[0];
        // Gleiche Pflicht wie in den Einstellungen (Paragraf 356 BGB): die
        // Minuten stehen sofort bereit, also braucht es die Zustimmung vorher.
        if (!consentEl || !consentEl.checked) {
            VCS.ui?.showToast?.(t('minutesConsentRequired') || '', 'warning', 6000);
            consentEl?.focus();
            return;
        }
        const consentText = $('#minutesSheetOverlay .settings-minutes-consent span')[0]?.textContent || '';
        btn.disabled = true;
        try {
            const opened = await VCS.chatSetup?.startPackageCheckout(packageId, consentText);
            // Blatt zu, sobald Stripe offen ist: der Nutzer bezahlt jetzt im
            // anderen Tab, hier soll er waehrenddessen sein Gegenueber sehen.
            if (opened) {
                this.closeSheet();
                VCS.ui?.showToast?.(t('minutesCheckoutOpened') || '', 'info', 8000);
            }
        } finally {
            btn.disabled = false;
        }
    }

    // ── Private ──────────────────────────────────────────────

    _show(mode, text, canBuy) {
        if (!this._view) return;
        this._mode = mode;
        this._view.noticeText.text(text);
        this._view.btnBuy.toggleClass('hidden', !canBuy);
        this._view.notice
            .toggleClass('call-cap-notice--expired', mode === 'expired')
            .removeClass('hidden');
    }

    _hideNotice() {
        clearTimeout(this._hideTimer);
        this._hideTimer = 0;
        this._mode = null;
        this._view?.notice?.addClass('hidden');
    }
};

// Singleton, beim Bundle-Init angehaengt (analog VCS.audioFader).
VCS.liveCapNotice = new VCS.LiveCapNotice();
